import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateMaintenanceWindowsApp = document.createElement('template');

templateMaintenanceWindowsApp.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
    <gz-push-body-layout resizable="right">
     <div slot="push-body-sidenav-title">
        <gz-title id="filtersTitle" class="title" fontSize="11" fontweight="600"></gz-title>
    </div>

    <div slot="push-body-sidenav">
        <gz-maintenance-windows-side-nav></gz-maintenance-windows-side-nav>
    </div>

    <div slot="push-body-content" class="content">
          <gz-maintenance-window-grid></gz-maintenance-window-grid>
    </div>
</gz-push-body-layout>
    <div>
        <gz-maintenance-window-form class="new-maintenance-window"></gz-maintenance-window-form>
    </div>
`;
